
export const getCookie = (sName) =>
{
    sName = sName.toLowerCase();
    const oCrumbles = document.cookie.split(';');
    for(let i = 0; i < oCrumbles.length; i++)
    {
        const oPair = oCrumbles[i].split('=');
        const sKey = decodeURIComponent(oPair[0].trim().toLowerCase());
        const sValue = oPair.length > 1 ? oPair[1] : '';
        if(sKey === sName) {
            return decodeURIComponent(sValue);
        }
    }
    return '';
};
export const setCookie = (sName, sValue, expireDate) =>
{
    if (process.env.VUE_APP_DEBUG_LOG) { console.log(sName, sValue); }
    if (!expireDate) {
        expireDate = new Date();
        expireDate.setYear(expireDate.getFullYear() + 1);
    }
    const sCookie = encodeURIComponent(sName) + '=' + encodeURIComponent(sValue) + ';expires=' + expireDate.toGMTString() + ';path=/';
    document.cookie = sCookie;
};
export const clearCookie = (sName) => {document.cookie = sName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/'; };
